module.exports = __webpack_public_path__ + "711a78762c794d57c70f28ee458612bf.png";